import { render, staticRenderFns } from "./PostcodeLookup.vue?vue&type=template&id=91f6e0ae&"
import script from "./PostcodeLookup.vue?vue&type=script&lang=js&"
export * from "./PostcodeLookup.vue?vue&type=script&lang=js&"
import style0 from "./PostcodeLookup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports